// Import Packages
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

// Import Pages
import NewDeleteConfirm from "../DataTable/NewDeleteConfirm";

// Import Material UI
import { Button, Dialog, DialogTitle, Box } from "@material-ui/core/";
import { Alert, AlertTitle } from "@material-ui/lab";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Close from "@material-ui/icons/Close";
import Grid from "@material-ui/core/Grid";

// Import Recoil
import { useSetRecoilState } from 'recoil';
import { alertState } from "../../recoil-store/recoil-state";

// Import Helper
import { getExtension } from "../../helpers/helper";

// Import CSS
import './ImportModal.css'


const ImportModal = ({ setOpenImport, importFunc, setTempImportFile }) => {
    const [file, setFile] = useState();
    const [loading, setLoading] = useState(false);
    const [openOverrideConfirm, setOpenOverrideConfirm] = useState(false);
    const { t } = useTranslation();
    const setAlert = useSetRecoilState(alertState);

    const handleClose = () => {
        setOpenImport(false);
        if (setTempImportFile) {
            setTempImportFile(undefined)
        }
    };

    const handleClick = () => {
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = '.json';
        fileInput.onchange = handleInputChange;
        fileInput.click();
    }


    const handleInputChange = (event) => {
        if (event.target.files[0]?.name) {
            let extension = getExtension(event.target.files[0]?.name);
            if (extension === 'json') {
                setFile(event.target.files[0]);
            } else {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t('MESSAGES.LICENSE.LICENSE-XML-FORMAT'),
                    severity: 'error'
                }));
            }
        }
    };

    const removeSelectedFile = async (e) => {
        setFile("")
        const input = document.querySelector('input');
        input.value = "";
    }

    const handleSubmit = async () => {
        if (!file) {
            return;
        }
        setLoading(true);
        await importFunc(file, true);
        setTimeout(() => {
            setLoading(false);
        }, 500)

    };

    return (
        <Dialog
            id="import-modal"
            open={true}
            onClose={handleClose}
            PaperProps={{
                style: {
                    overflowX: "hidden",
                    width: "20%"
                },
            }}
        >
            <DialogTitle
                id="alert-dialog-title"
            >
                <div id="about-title">
                    <b>{t('CONTENT.FLOW.IMPORT-MODAL-HEADER')}</b>
                    <Button data-test="cancelautom-button" onClick={handleClose}>
                        <Close />
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent>
                <div style={{ textAlign: "left", marginTop: 20 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} style={{ textAlign: "center" }}>
                            <Button className='dialog-add-button' onClick={handleClick}>{t('CONTENT.FLOW.CHOOSE-JSON-FILE')}</Button>
                        </Grid>
                        {file?.name && <Grid item xs={12} style={{ textAlign: "center" }}>
                            <Alert onClose={removeSelectedFile}>{file?.name}</Alert>
                        </Grid>
                        }
                        {file?.name && <Grid item xs={12} style={{ textAlign: "center" }}>
                            <Button
                                disabled={!file?.name || loading}
                                variant="contained"
                                color="success"
                                // onClick={handleSubmit}
                                onClick={() => setOpenOverrideConfirm(true)}
                            >
                                {t('CONTENT.ROLE.SAVE')}
                            </Button>
                        </Grid>
                        }
                    </Grid>
                </div>
            </DialogContent>
            <DialogActions
                style={{
                    justifyContent: "space-between",
                    padding: "8px 24px 16px 24px",
                }}
            >

            </DialogActions>
            {openOverrideConfirm ? <NewDeleteConfirm titleMessage={t("MESSAGES.AUTOMS.OVERRIDE-AUTOM")} setOpenDelete={setOpenOverrideConfirm} isOkCustomColor={"#4F6E90"}
                deleteFunc={handleSubmit} cancelButtonLabel={t("MESSAGES.AUTOMS.CONFIRM")} /> : ""}
        </Dialog>
    );
};

export default ImportModal;
